import React from 'react'

function BuildingIcon() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M7.08301 26.0834V16.1667H9.91634V26.0834H7.08301ZM15.583 26.0834V16.1667H18.4163V26.0834H15.583ZM2.83301 31.75V28.9167H31.1663V31.75H2.83301ZM24.083 26.0834V16.1667H26.9163V26.0834H24.083ZM2.83301 13.3334V10.5L16.9997 3.41669L31.1663 10.5V13.3334H2.83301ZM9.13718 10.5H24.8622L16.9997 6.60419L9.13718 10.5Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export default BuildingIcon
